import { Injectable, EventEmitter } from '@angular/core';
import { Item } from '../../../core/models/item.model';
import { RestService } from '../../utils/services/rest.service';
import { AuthService } from '../../utils/services/auth.service';
import { IGift } from 'src/app/core/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class GiftBagService {

  private items: Item[] = [];

  private historicItemsBag = [];

  public newItemBagEvent$ = new EventEmitter();

  public changeItems$ = new EventEmitter();

  private isExistis = false;

  constructor(
    private restService: RestService,
    private authService: AuthService
  ) { }

  public verifyItemExistis(itemDescription: string): boolean {
    const index = this.historicItemsBag.findIndex(description => description === itemDescription);
    if (index >= 0) {
      this.isExistis = true;
    } else {
      this.isExistis = false;
    }
    return this.isExistis;
  }

  public setItemBag(newItem: Item): void {
    if (newItem.description) {
    this.historicItemsBag.push(newItem.description);
     this.items.push(newItem);
    }
  }

  public getItemsBag() {
    return this.items;
  }

  public removeItemBag(description: string) {
    const newItemsList = [];
    let itemRemove = null;
    this.items.map(item => {
      if (item.description !== description) {
        newItemsList.push(item);
      } else {
        itemRemove = item;
      }
    });
    this.items = newItemsList;
    this.removeItemHistoric(description);
    this.changeItems$.next(this.items);
    this.subtraiSelecaoItem(itemRemove);
    this.updateUser(description);
  }

  removeItemHistoric(itemDescription: string) {
    const index = this.historicItemsBag.findIndex(description => description === itemDescription);
    if (index >= 0) {
      this.historicItemsBag.splice(index, 1);
    }
  }

  private subtraiSelecaoItem(item: IGift) {
    if (item.confirmedQuantity > 0) {
      if (item.confirmedQuantity === 1) {
        item.confirmedQuantity = 0;
      } else {
        item.confirmedQuantity--;
      }
    }
    
    if (this.isLimitReached(item)) {
      item.status = false;
    } else {
      item.status = true;
    }
    this.restService.updateItem(item, item.key, true);
  }

  private isLimitReached(item: Item): boolean {
    return item.limitQuantity === item.confirmedQuantity;
  }

  private updateUser(description: string) {
    const user: any = this.authService.getUser();
    user.bag = this.formatForArray(user.bag);
    const listaCorreta = user.bag.filter(item => item.gift.description !== description)
    user.bag = listaCorreta;
    this.restService.updateUser(user.key, user);
  }

  private formatForArray = (data: any) => Object.values(data).map((item) => item);
}
